"use client";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Cookie get function
const getCookie = (name) => {
  if (typeof document === "undefined") return null;
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="));
  return cookie ? cookie.split("=")[1] : null;
};

let storedToken = null;
let storedUserInfo = null;

if (typeof window !== "undefined") {
  storedToken = getCookie("velormall_userToken");
  const userString = localStorage.getItem("velormall_chat_userInfo");
  storedUserInfo = userString ? JSON.parse(userString) : null;
}

// LocalStorage theke userId niye API call
export const fetchAuthData = createAsyncThunk(
  "auth/fetchAuthData",
  async (_, { rejectWithValue }) => {
    try {
      if (!storedUserInfo?.id) {
        return rejectWithValue("No userId found in localStorage");
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/user/view/${storedUserInfo?.id}`,
        { withCredentials: true } // cookie padano jonno
      );
      // console.log(data);
      return data?.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    AuthInfo: storedUserInfo || null,
    token: storedToken || null,
    isAuthenticated: !!storedToken,
    AuthData: null,
    isAuthLoading: false,
    AuthDataError: null,
  },
  reducers: {
    setCredentials: (state, action) => {
      state.AuthInfo = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem("velormall_chat_userInfo", JSON.stringify(action.payload));
      }
    },
    logout: (state) => {
      state.AuthInfo = null;
      state.AuthData = null;
      if (typeof window !== "undefined") {
        localStorage.removeItem("velormall_chat_userInfo");
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuthData.pending, (state) => {
        state.isAuthLoading = true;
        state.AuthDataError = null;
      })
      .addCase(fetchAuthData.fulfilled, (state, action) => {
        state.isAuthLoading = false;
        state.AuthData = action.payload;
      })
      .addCase(fetchAuthData.rejected, (state, action) => {
        state.isAuthLoading = false;
        state.AuthDataError = action.payload;
      });
  },
});


export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
